export const GET_FINANCIAL_CREDIT_REQUEST_INFO = 'GET_FINANCIAL_CREDIT_REQUEST_INFO';
export const GET_FINANCIAL_CREDIT_REQUEST_INFO_SUCCESS = 'GET_FINANCIAL_CREDIT_REQUEST_INFO_SUCCESS';
export const GET_FINANCIAL_CREDIT_REQUEST_INFO_ERROR = 'GET_FINANCIAL_CREDIT_REQUEST_INFO_ERROR';

export const PUT_MARK_AS_PAID = 'PUT_MARK_AS_PAID';
export const PUT_MARK_AS_PAID_SUCCESS = 'PUT_MARK_AS_PAID_SUCCESS';
export const PUT_MARK_AS_PAID_ERROR = 'PUT_MARK_AS_PAID_ERROR';